function initializeSidebarToggle() {
    const sidebarTitles = document.querySelectorAll('.sidebar__title');
    
    if (!sidebarTitles.length) {
        return;
    }

    sidebarTitles.forEach(function(title, index) {
        const siblingList = findSibling(title, 'ul');
        const siblingSections = findSibling(title, '.sidebar__sections');

        // If a UL sibling was not found for this title, skip it.
        if (!siblingList && !siblingSections) {
            return;
        }

        // Titles with a real <button> (keyboard accessible) carry the ARIA state on the button.
        const toggle = title.querySelector('button') || title;
        const controlled = siblingList || siblingSections;

        if (toggle !== title) {
            if (!controlled.id) {
                controlled.id = 'sidebar-toc-' + index;
            }
            toggle.setAttribute('aria-controls', controlled.id);
        }
        
        // Add the click listener
        title.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Toggle the classes on the title and the UL sibling
            title.classList.toggle('is-active');
            if (siblingList) {
                siblingList.classList.toggle('is-open');
            }

            if (siblingSections) {
                siblingSections.classList.toggle('is-open');
            }
            
            // Update ARIA attribute
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !isExpanded);
        });
    });
}

function findSibling(element, selector) {
    let sibling = element.nextElementSibling;
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    return null; // No matching sibling was found
}

function setSubMenuExpanded(toggle, expanded) {
    const parentLi = toggle.closest('li');
    const ul = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!parentLi || !ul) {
        return;
    }

    ul.classList.toggle('is-open', expanded);
    parentLi.classList.toggle('is-active', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
}

function initializeSidebarToggleSubMenu() {
    const toggles = document.querySelectorAll('.sidebar__left-toggle');

    toggles.forEach(function(toggle) {
        if (!document.getElementById(toggle.getAttribute('aria-controls'))) {
            console.warn('Could not find the sub menu controlled by', toggle);
            return;
        }

        toggle.addEventListener('click', function() {
            setSubMenuExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
    });
}

function initializeResponsiveHeroPadding() {
    const pageHero = document.querySelector('.page-hero');
    const sidebar = document.querySelector('.sidebar__left');

    // If the hero or sidebar elements don't exist on this page, do nothing.
    if (!pageHero || !sidebar) {
        return;
    }

    // Define the media query for mobile/tablet.
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    /**
     * The core function to add or remove the padding class based on screen size.
     */
    function updatePaddingClass() {
        if (mediaQuery.matches) {
            // If the screen is mobile/tablet size, add the class.
            pageHero.classList.add('page-hero--extra-padding');
        } else {
            // If the screen is larger, remove the class.
            pageHero.classList.remove('page-hero--extra-padding');
        }
    }

    // 1. Run the check once when the page first loads.
    updatePaddingClass();

    // 2. Add a listener to run the check again whenever the viewport
    //    crosses the breakpoint (e.g., on browser resize).
    mediaQuery.addEventListener('change', updatePaddingClass);
}

function initializeSidebarLeftMobileMenu() {
    const sidebar = document.querySelector('.sidebar__left');
    const sidebarLabel = document.querySelector('.sidebar__left-label');
    const sidebarMenu = document.querySelector('.sidebar__left-menu');

    if (!sidebar || !sidebarLabel || !sidebarMenu) {
        return;
    }

    function setMenuExpanded(expanded) {
        sidebarMenu.classList.toggle('is-open', expanded);
        sidebarLabel.setAttribute('aria-expanded', String(expanded));
    }

    sidebarLabel.addEventListener('click', function() {
        setMenuExpanded(sidebarLabel.getAttribute('aria-expanded') !== 'true');
    });

    // Handled on the sidebar itself (and stopped there) so the global Escape handler in navigation.js doesn't steal focus.
    sidebar.addEventListener('keydown', function(e) {
        const isMobileMenuOpen = sidebarLabel.getAttribute('aria-expanded') === 'true' && sidebarLabel.offsetParent !== null;

        if (e.key === 'Escape' && isMobileMenuOpen) {
            e.stopPropagation();
            setMenuExpanded(false);
            sidebarLabel.focus();
        }
    });
}

function initializeSidebarStickyOffset() {
    const sidebar = document.querySelector('.sidebar__left');
    const sidebarLabel = document.querySelector('.sidebar__left-label');
    const header = document.querySelector('.site-header');

    if (!sidebar || !sidebarLabel) {
        return;
    }

    const mediaQuery = window.matchMedia('(max-width: 1023.98px)');

    // The fixed mobile/tablet menu sits directly under the fixed header, whose real height differs from the CSS variables.
    // It also covers the top of the viewport, so anchors and scroll targets need to clear it.
    function update() {
        if (mediaQuery.matches) {
            if (header) {
                sidebar.style.setProperty('--sidebar-left-top', header.getBoundingClientRect().bottom + 'px');
            }
            const offset = sidebarLabel.getBoundingClientRect().bottom + 16;
            document.documentElement.style.setProperty('--handbook-anchor-offset', offset + 'px');
        } else {
            sidebar.style.removeProperty('--sidebar-left-top');
            document.documentElement.style.removeProperty('--handbook-anchor-offset');
        }
    }

    update();
    window.addEventListener('resize', update);
    mediaQuery.addEventListener('change', update);
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (header && 'ResizeObserver' in window) {
        new ResizeObserver(update).observe(header);
    }
}

function initializeSidebarScrollToContent() {
    const sidebarLinks = document.querySelectorAll('.sidebar__left-list a');

    sidebarLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            sessionStorage.setItem('scrollToContent', '1');
        });
    });

    if (sessionStorage.getItem('scrollToContent')) {
        sessionStorage.removeItem('scrollToContent');
        const content = document.querySelector('.content-layout__main');
        if (content) {
            content.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}

function initCourseDates() {

    document.querySelectorAll('.course-dates-wrapper').forEach(wrapper => {

        const toggle = wrapper.querySelector('.course-dates-toggle');

        if (!toggle) {
            return;
        }

        const showText = toggle.dataset.showText;
        const hideText = toggle.dataset.hideText;

        toggle.addEventListener('click', (e) => {
            e.preventDefault();

            const isOpen = wrapper.classList.toggle('is-open');

            toggle.textContent = isOpen
                ? hideText
                : showText;
        });
    });
}

function initSidebar() {
    initializeSidebarToggle();
    initializeSidebarToggleSubMenu();
    initializeResponsiveHeroPadding();
    initializeSidebarLeftMobileMenu();
    initializeSidebarStickyOffset();
    initializeSidebarScrollToContent();
    initCourseDates();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebar);
} else {
    initSidebar();
}
